import useAuth from '@app/auth/use-auth';

import { CollectionDetail } from '@shared/api/types';
import AverageCarbonIntensity from '../components/average-carbon-intensity';
import NumberProductAndIngredients from '../components/number-products-and-ingredients';
import ProductsStatusBreakdown from '../components/products-status-breakdown';

interface CollectionDashboardHeaderProps {
  collection: CollectionDetail;
}

const CollectionDashboardHeader = ({
  collection,
}: CollectionDashboardHeaderProps) => {
  const { user } = useAuth();
  const {
    averageEmissionsPerKg,
    numProducts,
    numIngredients,
    numProductsInProgress,
    numProductsDraft,
    numProductsComplete,
    numProductsEditing,
  } = collection;
  return (
    <div className="mt-4 w-full items-center justify-between space-y-4 sm:flex sm:flex-col md:flex md:flex-row md:items-end md:space-x-4">
      <div className="flex size-full flex-col rounded-lg sm:flex-row">
        <AverageCarbonIntensity
          averageEmissionsPerKg={averageEmissionsPerKg!}
        />
        <NumberProductAndIngredients
          numProducts={numProducts}
          numIngredients={numIngredients}
        />
      </div>
      {user!.productCategory === 'product' && (
        <ProductsStatusBreakdown
          calculating={numProductsInProgress}
          draft={numProductsDraft}
          complete={numProductsComplete}
          editing={numProductsEditing}
        />
      )}
    </div>
  );
};

export default CollectionDashboardHeader;
